module.exports = __webpack_public_path__ + "static/media/Carpentar.fb631f8e.jpg";